var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    transform: "",
    id: "injected-svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.94,15.5c.71.46,1.65.27,2.12-.44,0,0,0,0,0,0l3.96-6.04s0-.02,0-.03c0-.02-.03-.02-.04-.01l-6.04,3.96c-.71.46-.91,1.41-.44,2.12.12.18.27.33.44.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.08,20h13.85c.71,0,1.37-.37,1.72-.97,0,0,0,0,0,0,1.09-1.87,1.54-4.02,1.29-6.2-.52-4.58-4.23-8.26-8.81-8.77-2.84-.31-5.69.6-7.8,2.49-2.11,1.9-3.33,4.61-3.33,7.45,0,1.77.47,3.51,1.36,5.03.35.6,1.01.97,1.72.97Zm1.58-11.96c1.49-1.33,3.35-2.04,5.33-2.04.3,0,.61.02.92.05,3.66.4,6.62,3.35,7.04,7.01.2,1.74-.15,3.45-1.02,4.95h0s-13.84.02-13.84.02c-.71-1.22-1.08-2.61-1.08-4.02,0-2.27.97-4.44,2.66-5.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.a86d15ba2008fb5223948cc83dfa44dd.svg";
export { ForwardRef as ReactComponent };